import { render, staticRenderFns } from "./ManagementReport.vue?vue&type=template&id=87beee0a&"
import script from "./ManagementReport.vue?vue&type=script&lang=ts&"
export * from "./ManagementReport.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports